<h3>Verzekering opzeggen</h3>
<form [formGroup]="form" (ngSubmit)="onSubmit()">
    <ng-container *ngIf="purchasedProduct?.productId === policyProductEnum.Car">
        <wuc-form-field [hasNoState]="true">
            <wuc-form-field-label>Waarom wilt u opzeggen?</wuc-form-field-label>
            <div>
                <wuc-input-radio name="reason" formControlName="reason" [value]="endProductReasonEnum.NotNeeded">
                    De verzekering is niet meer nodig
                </wuc-input-radio>
                <wuc-input-radio name="reason" formControlName="reason" [value]="endProductReasonEnum.Premium">
                    De premie van de verzekering past niet meer bij mij
                </wuc-input-radio>
                <wuc-input-radio name="reason" formControlName="reason" [value]="endProductReasonEnum.Other">
                    Andere reden
                </wuc-input-radio>
            </div>
        </wuc-form-field>
        <p *ngIf="reason.value" [ngSwitch]="reason.value">
            <wuc-icon-ui icon="information" size="xs"></wuc-icon-ui>
            <ng-container *ngSwitchCase="endProductReasonEnum.NotNeeded">
                We begrijpen dat u de verzekering wilt opzeggen. Als u uw auto verkoopt of een tijdje niet meer
                gebruikt, dan is het belangrijk om te weten dat u wettelijk verplicht bent om verzekerd te zijn
                zolang de auto op uw naam staat. Gebruikt u de auto een tijdje niet, dan kunt u via RDW het kenteken
                laten schorsen en daarna de verzekering beëindigen.
            </ng-container>
            <ng-container *ngSwitchCase="endProductReasonEnum.Premium">
                Wat jammer dat u de premie nu te hoog vindt. Aan het einde van het jaar berekenen bijna alle andere
                verzekeraars opnieuw de premie. Die valt soms hoger uit door bijvoorbeeld uitgekeerde schades. Let
                op: laat u niet lokken met een (te) lage premie, die kunnen snel stijgen. Maak uw keuze bewust. Wilt
                u overstappen naar een andere verzekeraar? Weet dan dat u altijd terug mag komen.
            </ng-container>
            <ng-container *ngSwitchCase="endProductReasonEnum.Other">
                Wat jammer dat u de verzekering wil opzeggen. We hopen u natuurlijk weer terug te zien.
            </ng-container>
        </p>
    </ng-container>
    <p>
        Zolang dit kenteken op uw naam staat, is een verzekering (minimaal WA) verplicht! Vergeet hem dus niet te
        schorsen als u de {{ productName }} niet gebruikt.
    </p>
    <wuc-input-checkbox [formControl]="suspendIndication" name="suspendIndication" e2e="suspendIndication">
        Tuurlijk, houd ik rekening mee!
    </wuc-input-checkbox>
    <ng-container *ngIf="suspendIndication.value">
        <wuc-form-field>
            <wuc-form-field-label>Per wanneer?</wuc-form-field-label>
            <div>
                <wuc-input-radio name="endDateIndication" formControlName="endDateIndication" [value]="endDateIndicationEnum.Immediately">
                    Meteen opzeggen
                </wuc-input-radio>
                <wuc-input-radio name="endDateIndication" formControlName="endDateIndication" [value]="endDateIndicationEnum.WithFutureDate">
                    Opzeggen met een datum in de toekomst
                </wuc-input-radio>
            </div>
        </wuc-form-field>
        <wuc-form-field *ngIf="endDateIndication.value === endDateIndicationEnum.WithFutureDate">
            <wuc-form-field-label>Wat is de laatste dag waarop u verzekerd wilt zijn?</wuc-form-field-label>
            <wuc-input-date-picker
                formControlName="endDate"
                [selectPastDates]="false"
                [selectToday]="false"
            ></wuc-input-date-picker>
            <wuc-input-alert *ngIf="endDate.touched && endDate.hasError('required')">
                Vul uw einddatum in.
            </wuc-input-alert>
        </wuc-form-field>
        <p *ngIf="errors?.length">
            <wuc-card cardStyle="tertiary" padding="medium">
                <wuc-list icon="cross">
                    <wuc-list-item *ngFor="let error of errors">{{ error.message }}</wuc-list-item>
                </wuc-list>
            </wuc-card>
        </p>
        <wuc-form-field>
            <wuc-form-field-label></wuc-form-field-label>
            <wuc-button [isSubmitButton]="true" [disabled]="isDisabled" [isFullWidth]="true">Opzeggen</wuc-button>
        </wuc-form-field>
    </ng-container>
</form>
